import { OEM_META } from "@/components/OEM"
import { isSSR } from "@/utils/Helpers"
import { logError } from "@/utils/LoggingUtil"
import axios from "axios"
import "@/utils/axiosSetup"

export const BODY_STYLES = {
  "sedan": { body_type: [ "4dr Car", "Sedan" ], title: "Sedans", label: "Sedan" },
  "coupe": { body_type: [ "2dr Car", "Coupe", "Convertible" ], title: "Coupes", label: "Convertible" },
  "sport": { body_type: [ "2dr Car", "Coupe", "Convertible" ], title: "Sport Vehicles", label: "Sport" },
  "suv": { body_type: [ "Sport Utility", "Crossover" ], title: "SUVs", label: "SUV" },
  "minivan": { body_type: [ "Mini-van, Passenger", "Mini-van"], title: "Minivans", label: "Minivan" },
  "crossover": { body_type: [ "Crossover", ], title: "Crossovers", label: "Crossover" },
  "hatchback": { body_type: [ "Hatchback", ], title: "Hatchbacks", label: "Hatchback" },
  "convertible": { body_type: [ "Convertible", ], title: "Convertibles", label: "Convertible" },
  "truck": { body_type: [ "Crew Cab Pickup", "Extended Cab Pickup" ], title: "Pickup Trucks", label: "Pickup Truck" },
}

export const fuelTypes = ['Gasoline', 'Diesel', 'Electric', 'Hybrid']

const FILTERS_AS_ARRAY = ['condition','brand','body','color','year', 'fuel']

export const colors = ['White', 'Black', 'Blue', 'Silver', 'Gray', 'Red', 'Beige', 'Green', 'Yellow', 'Brown']

export function isBodyType(value) {
  return Object.keys(BODY_STYLES).indexOf(value) >= 0
}

export function isFuelType(value) {
  return fuelTypes.indexOf(value) >= 0
}

export function isColorPresent(value) {
  return colors.indexOf(value) >= 0
}

export function detailPageUrl(inventory) {
  const namePart = inventory.full_name.replaceAll(" ", "-").replaceAll("/", "-").replaceAll("'", "").replaceAll("\"", "")
  return '/vehicle/' + inventory.id + '/' + namePart
}

export async function searchOnPageLoad(props) {
  const urlParams = getFiltersFromParams(props)
  const recentViewedCount = parseInt(props.site.inventory.recent_viewed_limit || 5)
  const myVins = (props.site.session?.vehicles?.viewed && props.site.session?.vehicles?.viewed.length > 0 ? props.site.session?.vehicles?.viewed : []).slice(-recentViewedCount)
  const filters = Object.assign({},
    props.site.inventory.filters, 
    urlParams,
    props.site.session?.vehicles?.viewed && myVins.length > 0 ? { my_vins: myVins } : {},
    { cache: true }
  )
  let list = await searchInventory(props.site, filters, null, "list", true)
  let vinItems = []
  list.results.map((item,index) => {
    const vinIndex = myVins.indexOf(item.vin)
    if (vinIndex >= 0) {
      vinItems.push(item)
    }
  })
  list.results = list.results.filter(item => {
    return !myVins.includes(item.vin)
  })
  vinItems.map(item => {
    list.results.splice(0, 0, item)
  })
  return list
}

export async function searchInventory(site, params, facets, attributes, hasUrlInfo) {
  const paramList = {}
  Object.keys(params).map(key => {
    if (key != 'clear' && key != 'budget') {
      if (params[key] && Array.isArray(params[key])) {
        if (params[key].length > 0) paramList[key] = params[key]
      } else if (params[key]) {
        paramList[key] = params[key]
      }
    }
  })
  if (facets) {
    paramList["facets"] = facets
  }
  if (attributes) {
    paramList["fields"] = attributes
  }
  if (params.dealer_id) {
    paramList["did"] = Array.isArray(params.dealer_id) ? params.dealer_id : [ params.dealer_id ]
  } else if (params.did) {
    paramList["did"] = Array.isArray(params.did) ? params.did : [ params.did ]
  } else {
    paramList["did"] = site.dealer_ids
  }
  if (params.dl) {
    paramList["did"] = Array.isArray(params.dl) ? params.dl : [ params.dl ]
  }
  if (!facets && !params.rows) {
    paramList["rows"] = (site.inventory?.rows || 25)
  }
  if (!site.inventory?.show_zero_price) {
    paramList['min_price'] = 1
  }
  if (hasUrlInfo && site.inventory?.urlInfo?.page) {
    paramList["rows"] = site.inventory?.rows * Number(site.inventory.urlInfo.page)
  }

  const location = params.location || site?.session?.vehicles?.location

  paramList.sort = [...(params.sort || [])]

  if (site.inventory?.no_photos_last) {
    paramList.sort.push("no_photos_last")
  }

  if ((!params.sort || params?.sort.length == 0) && params.max_price ) {
    paramList.sort.push("price-desc")
  }

  if (!params.id && !params.vin && !params.sort ) paramList.sort.push("price")
  
  if (site.inventory?.no_photos_last) {
    paramList.sort.push("no_photos_last")
  }

  if (!params.id && !params.vin && !params.sort) paramList.sort.push("price")

  if (location && Object.keys(location).length > 0 && !params.id && !params.vin && !params.dealer_id) {
    paramList["lat"] = location.lat
    paramList["lon"] = location.lon
    paramList["radius"] = location.distance
    if (!paramList.sort.includes('location')) paramList.sort.push("location")
  }

  const minPrice = site.inventory?.min_price || 5000
  const maxPrice = site.inventory?.max_price || 150000

  //  Ignore sanity value if budget filter is applied
  if (!params.max_price && maxPrice) {
    paramList['max_price'] = maxPrice
  }

  if (minPrice < maxPrice && (!params['max_price'] || minPrice < Number(params['max_price']))) {
    paramList['min_price'] = minPrice
  }
  
  const serverUrl = isSSR() ? process.env.API_SERVER : "/engine"

  try {
    const resp = await axios.post(serverUrl + "/api/inventory/search", paramList, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    })
    if (resp.status == 200) {
      return _standardizeVehiclePrice(resp.data)
    } else {
      const errorMessage = "HTTP " + resp.status + ": " + serverUrl + "/api/inventory/search"
      const errorData = {
        url: serverUrl + "/api/inventory/search",
        payload: paramList,
        response: resp.data
      }
      logError(errorMessage, errorData)
    }  
  } catch (ex) {
    const errorData = {
      url: serverUrl + "/api/inventory/search",
      payload: paramList,
    }
    logError(ex, errorData)
}

}

function _standardizeVehiclePrice(inventory) {
  if(inventory && inventory.results.length > 0) {
    inventory?.results?.forEach(vehicle => {
      if(vehicle.prices.dealer_disc_price > 0 && vehicle.prices.dealer_accessories_price == 0) {
        // UI should be using only two prices, so we are standardising the price by replacing original "price" value with 
        // "dealer_disc_price" when "dealer_disc_price" is available.
        vehicle.prices.price = vehicle.prices.dealer_disc_price
        vehicle.prices.dealer_disc_price = 0
      }
      vehicle.discount = _calculateDiscount(vehicle)
    })
  }
  return inventory
}

function _calculateDiscount(vehicle) {
  const { prices } = vehicle || {};
  if (!prices) return 0;

  const { msrp = 0, dealer_disc_price = 0, dealer_accessories_price = 0, price = 0 } = prices;

  if (dealer_disc_price > 0) {
    return dealer_accessories_price > 0 
      ? (msrp + dealer_accessories_price) - price 
      : msrp - dealer_disc_price;
  }

  return msrp && price ? msrp - price : 0;
}


export function inventoryPhotoUrl(site, item, url) {
  if (item && (!item.photos?.num_photos || item.photos?.num_photos == 0)) {
    if (item.photos.stock_image) return item.photos.stock_image
    else return site.inventory?.missing_image
  }
  if (!url) {
    url = process.env.NEXT_PUBLIC_INV_CDN + "/" + item.id + "/img_0_lg.jpg"
  }
  url = url.replace("http://localhost:3000/static", process.env.NEXT_PUBLIC_INV_CDN + "/inv")
    .replace("[inv_cdn]/st", process.env.NEXT_PUBLIC_INV_CDN)
    .replace("[inv_cdn]/vp/dev", process.env.NEXT_PUBLIC_INV_CDN)
    .replace("[inv_cdn]/vp/sta", process.env.NEXT_PUBLIC_INV_CDN)
    .replace("[inv_cdn]", process.env.NEXT_PUBLIC_INV_CDN)
  return url
}

export function inventoryPhotos(site, item) {
  if (item && (!item.photos?.num_photos || item.photos?.num_photos == 0)) {
    if (item.photos.stock_image) return [{ image: item.photos.stock_image, flipHorizontal: true }]
    else return [{ image: site.inventory?.missing_image }]
  }
  const extn = item.photos?.images[0].split(".")[item.photos?.images[0].split(".").length-1]
  let photos = []
  for (let i=0; i<item.photos?.num_photos - 1; i++) {
    photos.push({ image: process.env.NEXT_PUBLIC_INV_CDN + "/" + item.id + "/img_" + i + "_lg." + extn })
  }
  return photos
}

export function conditionLabel(value) {
  if (value == 1) return "New"
  if (value == 3) return "Certified Pre-owned"
  if (value == 2) return "Pre-owned"
}

export function getFiltersFromParams(props, filters) {
  if (!props.params) return {}
  const params = props.params
  let urlParams = {}
  let slugs = []
  Object.keys(params).map(key => {
    if (params[key] && key.indexOf("slug") != 0) {
      if (FILTERS_AS_ARRAY.includes(key) && params[key]) {
        urlParams[key] = params[key].split(",")
      } else {
        urlParams[key] = params[key]
      }
    }
  })
  if (filters) {
    Object.keys(filters).map(key => {
      if (filters[key] && key.indexOf("slug") != 0) {
        if (FILTERS_AS_ARRAY.includes(key) && params[key] && !Array.isArray(params[key])) {
          urlParams[key] = params[key].split(",")
        } else {
          urlParams[key] = params[key]
        }
      }
    })
  }
  if (params.slug) slugs.push(decodeURIComponent(params.slug))
  if (params.slug2) slugs.push(decodeURIComponent(params.slug2))
  if (params.slug3) slugs.push(decodeURIComponent(params.slug3))
  if (params.slug4) slugs.push(decodeURIComponent(params.slug4))
  slugs.map(value => {
    if (value == 'new' || value == "pre-owned" || value == "certified") {
      urlParams.condition = [value]
    }
    if (isBodyType(value)) {
      urlParams.body = [value]
    }
    if (isFuelType(value)) {
      urlParams.fuel = [value]
    }
    if (isColorPresent(value)) {
      urlParams.color = [value]
    }
    if (OEM_META[value.toLowerCase()]) {
      urlParams.brand = [value]
    }
  })
  return urlParams
}

export function inventoryPageMeta(params) {
  let meta = { title: "All Vehicles" }
  let description = []
  let slugs = []
  if (params.slug) slugs.push(params.slug)
  if (params.slug2) slugs.push(params.slug2)
  if (params.slug3) slugs.push(params.slug3)
  if (params.slug4) slugs.push(params.slug4)
  slugs.map((value,index) => {
    if (value == 'new') {
      slugs[index] = "New"
      description.push("New Vehicles.")
    }
    if (value == 'pre-owned') {
      slugs[index] = "Pre-owned"
      description.push("Pre-owned Vehicles.")
    }
    if (value == 'certified') {
      slugs[index] = "Certified"
      description.push("Certified Vehicles.")
    }
    if (isBodyType(value)) {
      slugs[index] = BODY_STYLES[value].title
      description.push(BODY_STYLES[value].title + " and other styles.")
    }
    if (OEM_META[value.toLowerCase()]) {
      slugs[index] = OEM_META[value.toLowerCase()].name
      description.push(OEM_META[value.toLowerCase()].name + " vehicles.")
    }
  })
  if (description.indexOf("New Vehicles") < 0 && description.indexOf("Pre-owned Vehicles") < 0 && description.indexOf("CErtified Vehicles") < 0) {
    description.push("New, Pre-owned and Certified Vehicles.")
  }
  if (slugs.length > 0) {
    meta.title = slugs.join(" ") + " Vehicles"
    meta.title = slugs.join(" ")
  }
  meta.description = description.join(" ")
  return meta
}

export function genInvUrl(params, item, selected) {
  
  let conditions = []
  let brands = []
  let bodyTypes = []
  let fuelTypes = []
  let colors = []

  let urlParams = []
  Object.keys(params).map(key => {
    if (params[key] && key.indexOf("slug") != 0 && key != "budget" && key != "my_vins" && key != "sort") {
      if (key == 'condition') conditions = Array.isArray(params[key]) ? [...params[key]] : params[key].split(",")
      else if (key == 'brand') brands = Array.isArray(params[key]) ? [...params[key]] : params[key].split(",")
      else if (key == 'body') bodyTypes = Array.isArray(params[key]) ? [...params[key]] : params[key].split(",")
      else if (key == 'fuel') fuelTypes = Array.isArray(params[key]) ? [...params[key]] : params[key].split(",")
      else if (key == 'color') colors = Array.isArray(params[key]) ? [...params[key]] : params[key].split(",")
      else if (Array.isArray(params[key])) params[key].length > 0 ? urlParams.push(key + "=" + encodeURIComponent(params[key])) : {}
      else urlParams.push(key + "=" + encodeURIComponent(params[key]))
    }
  })
  
  if (item.key == 'new' || item.key == 'pre-owned' || item.key == 'certified') {
    if (!conditions.includes(item.key)) conditions.push(item.key)
  }
  if (isBodyType(item.key)) {
    if (!bodyTypes.includes(item.key)) bodyTypes.push(item.key)
  }
  if (isFuelType(item.key)) {
    if (!fuelTypes.includes(item.key)) fuelTypes.push(item.key)
  }
  if (isColorPresent(item.key)) {
    if (!colors.includes(item.key)) colors.push(item.key)
  }
  if (OEM_META[item.key?.toLowerCase()]) {
    if (!brands.includes(item.key.toLowerCase())) brands.push(item.key)
  }

  let slugs = []
  if (params.slug) slugs.push(params.slug)
  if (params.slug2) slugs.push(params.slug2)
  if (params.slug3) slugs.push(params.slug3)
  if (params.slug4) slugs.push(params.slug4)  
  slugs.map((value,index) => {
    if (value == 'new' || value == 'pre-owned' || value == 'certified') {
      if (!conditions.includes(value)) conditions.push(value)
    }
    if (isBodyType(value)) {
      if (!bodyTypes.includes(value)) bodyTypes.push(value)
    }
    if (isFuelType(item.key)) {
      if (!fuelTypes.includes(item.key)) fuelTypes.push(item.key)
    }
    if (isColorPresent(item.key)) {
      if (!colors.includes(item.key)) colors.push(item.key)
    }
    if (OEM_META[value.toLowerCase()]) {
      if (!brands.includes(value)) brands.push(value)
    }
  })
  
  if (selected && (conditions.indexOf(item.key) >= 0)) {
    conditions.splice(conditions.indexOf(item.key), 1)
  }
  if (selected && (bodyTypes.indexOf(item.key) >= 0)) {
    bodyTypes.splice(bodyTypes.indexOf(item.key), 1)
  }
  if (selected && (fuelTypes.indexOf(item.key) >= 0)) {
    fuelTypes.splice(fuelTypes.indexOf(item.key), 1)
  }
  if (selected && (colors.indexOf(item.key) >= 0)) {
    colors.splice(colors.indexOf(item.key), 1)
  }
  if (selected && (brands.indexOf(item.key) >= 0)) {
    brands.splice(brands.indexOf(item.key), 1)
  }
  
  let prefix = ["vehicles"]
  if (conditions.length == 1) {
    prefix.push(conditions[0])
  } else if (conditions.length > 0) {
    urlParams.push("condition=" + conditions.join(","))
  }
  brands.map((b,i) => {
    brands[i] = OEM_META[b]?.name || b
  })
  if (brands.length == 1) {
    prefix.push(brands[0])
  } else if (brands.length > 0) {
    urlParams.push("brand=" + [...new Set(brands)].join(","))
  }
  if (bodyTypes.length == 1) {
    prefix.push(bodyTypes[0])
  } else if (bodyTypes.length > 0) {
    urlParams.push("body=" + bodyTypes.join(","))
  }
  if (fuelTypes.length == 1) {
    prefix.push(fuelTypes[0])
  } else if (fuelTypes.length > 0) {
    urlParams.push("fuel=" + fuelTypes.join(","))
  }
  if (colors.length == 1 ) {
    prefix.push(colors[0])
  } else if (colors.length > 0) {
    urlParams.push("color=" + colors.join(","))
  }
  
  return "/" + prefix.join("/") + (urlParams.length > 0 ? "?" + urlParams.join("&") : "")

}


export const PLACEHOLDER_IMAGE = "data:image/jpeg;base64,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"